<ng-template #content role="document" let-modal>
  <div class="modal-header p-3 border-1">
    <h5 class="modal-title mt-0">Recurrence starting {{ startDate | date: 'EE, M/d'}}</h5>
    <button type="button" class="btn-close" aria-hidden="true" (click)="onCancel(modal)"></button>
  </div>

  <div class="modal-body text-muted">
    <form [formGroup]="form" class="form-group">
      <div class="row g-0">
        <div class="col-3 align-self-center">Repeat every</div>
        <div class="col-9">
          <!-- <df-repeat [states]="everyPeriod" className="mx-3" (select)="selectEveryPeriod($event)"></df-repeat> -->
          <input type="number" #everyPeriodInput class="form-control every-period-input number-input"
            id="everyperiod" formControlName="everyperiod" [min]="1" [max]="7" [value]="selectedEveryPeriod" (change)="changeEveryPeriod()" (keypress)="cancelEnter($event)">
          <df-repeat [states]="periods" className="mx-3" (select)="selectPeriod($event)" [state]="periods.indexOf(selectedPeriod)"></df-repeat>
        </div>
      </div>

      <div *ngIf="selectedPeriod === 'week'" class="mt-2">
        <div class="d-block">Repeat on</div>
        <div class="weekdays mt-2">
          <div *ngFor="let d of weekdays; let i = index" class="weekday" [ngClass]="{selected: selectedDays[i]}" (click)="selectDay(i)">{{d}}</div>
        </div>
      </div>

      <div class="d-block mt-2">Ends</div>
      <div class="end-options mt-2">
        <!-- <div class="end-option" (click)="selectEndOption(0)">
          <i [class]="'bx bx-radio-circle' + (selectedEndOption === 0 ? '-marked' : '') + ' large'"></i>
          <span class="end-option-title">Never</span>
        </div> -->
        <div class="row g-0 end-option mt-2" (click)="selectEndOption(1)">
          <div class="col-3">
            <i [class]="'bx bx-radio-circle' + (selectedEndOption === 1 ? '-marked' : '') + ' large'"></i>
            <span class="end-option-title">After</span>
          </div>
          <div class="col-9">
            <input type="number" #endOccurences class="form-control end-occurence-input number-input" [ngClass]="{disabled: selectedEndOption !== 1}"
              id="endoccurences" formControlName="endoccurences" [min]="1" [max]="availableSessions" (change)="changeEndOccurances()" (keypress)="cancelEnter($event)">
            occurences
          </div>
        </div>

        <div class="row g-0 end-option mt-3" (click)="selectEndOption(2)">
          <div class="col-3">
            <i [class]="'bx bx-radio-circle' + (selectedEndOption === 2 ? '-marked' : '') + ' large'"></i>
            <span class="end-option-title">On</span>
          </div>
          <div class="col-9">
            <input #endDate class="flatpickr-input form-control" [ngClass]="{disabled: selectedEndOption !== 2}" type="text" mwlFlatpickr
              [convertModelValue]="true" [dateFormat]="'D, F d, Y'"
              id="enddate" formControlName="enddate" (change)="changeEndDate()" (keypress)="cancelEnter($event)">
          </div>
        </div>

        <span class="session-dates-title">Session Dates</span>
        <ul class="session-dates mt-3">
          <li *ngFor="let d of selectedSessionDates">{{d | date: 'EE, M/d'}} </li>
        </ul>
      </div>

      <div class="modal-footer">
        <div class="d-inline-block" style="margin-right: 3rem;">Available sessions: {{availableSessions}}</div>
        <button type="submit" class="btn btn-primary" [disabled]="!isFormValid()" (click)="onSubmit(modal);">Save</button>
      </div>
    </form>
  </div>
</ng-template>